import React from 'react';
import { BILLETERA_VIRTUAL_LABEL } from '../../utils/metodoPagoLabels';

/** Badge compacto de billetera virtual para cobros/licencia (sin marca externa). */
export default function MercadoPagoMark({ className = 'h-8 w-auto', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={BILLETERA_VIRTUAL_LABEL}
      viewBox="0 0 168 34"
      className={className}
      {...rest}
    >
      <rect width="168" height="34" rx="5" fill="#009ee3" />
      <text
        x="84"
        y="22"
        fill="#fff"
        textAnchor="middle"
        fontFamily="system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"
        fontSize="11"
        fontWeight="700"
        letterSpacing="0.01em"
      >
        {BILLETERA_VIRTUAL_LABEL}
      </text>
    </svg>
  );
}
